/*
 * Parfum4You fragrance preference engine.
 * Local and deterministic: no external service, key, tracking call or generated claim.
 */
(() => {
  'use strict';

  const tmCopy = {"Vous l’avez aimé": ["Hat Ihnen gefallen", "Le è piaciuto", "You liked it"], "Ajouté à « À découvrir »": ["Zu «Entdecken» hinzugefügt", "Aggiunto a «Da scoprire»", "Added to “To discover”"], "Dans votre budget": ["In Ihrem Budget", "Nel Suo budget", "Within your budget"], "Repères proches d’un parfum aimé": ["Ähnliches Duftprofil wie ein Parfum, das Ihnen gefällt", "Caratteristiche vicine a un profumo che Le piace", "Similar characteristics to a fragrance you liked"], "Disponible dans la sélection": ["In der Auswahl verfügbar", "Disponibile nella selezione", "Available in the selection"], "Création suisse Maison Solen proposée parmi les disponibilités.": ["Schweizer Kreation von Maison Solen aus den verfügbaren Produkten.", "Creazione svizzera Maison Solen proposta tra i prodotti disponibili.", "Swiss Maison Solen creation suggested from available products."], "Famille [[0]]": ["Duftfamilie [[0]]", "Famiglia [[0]]", "Fragrance family [[0]]"], "Accords retrouvés : [[0]]": ["Passende Akkorde: [[0]]", "Accordi corrispondenti: [[0]]", "Matching accords: [[0]]"], "Usage indiqué : [[0]]": ["Angegebener Anlass: [[0]]", "Uso indicato: [[0]]", "Listed occasion: [[0]]"], "Profil [[0]]": ["Duftprofil [[0]]", "Profilo [[0]]", "Profile [[0]]"]};
  function tmSay(source, ...values) {
    const index = ["de", "it", "en"].indexOf(typeof document === "undefined" ? "fr" : document.documentElement.lang.split("-")[0]);
    return (tmCopy[source]?.[index] ?? source).replace(/\[\[(\d+)\]\]/g, (_, i) => String(values[Number(i)] ?? ""));
  }


  const STORAGE_KEY = 'tm_fragrance_profile_v1';
  const STORAGE_TTL = 30 * 24 * 60 * 60 * 1000;

  const FAMILY_ALIASES = {
    floral: ['floral', 'florale', 'fleur', 'fleurs', 'rose', 'jasmin', 'hibiscus'],
    gourmand: ['gourmand', 'gourmande', 'sucre', 'sucres', 'sucree', 'sucrees', 'caramel', 'chocolat', 'praline'],
    boise: ['boise', 'boisee', 'bois', 'cedre', 'santal', 'oud', 'cuir'],
    frais: ['frais', 'fraiche', 'fraicheur', 'aquatique', 'propre'],
    agrume: ['agrume', 'agrumes', 'citron', 'orange', 'bergamote', 'mandarine'],
    fruite: ['fruite', 'fruitee', 'fruit', 'fruits', 'mangue', 'peche', 'pomme', 'passion'],
    oriental: ['oriental', 'orientale', 'dubaï', 'dubai', 'encens'],
    epice: ['epice', 'epicee', 'epices', 'poivre', 'cannelle', 'girofle'],
    musque: ['musque', 'musc', 'musc blanc'],
    vanille: ['vanille', 'vanillee'],
    ambre: ['ambre', 'ambree'],
  };

  const FAMILY_TERMS = {
    floral: ['floral', 'florale', 'fleur', 'fleurs'],
    gourmand: ['gourmand', 'gourmande', 'sucre', 'sucres', 'sucree', 'sucrees'],
    boise: ['boise', 'boisee'], frais: ['frais', 'fraiche', 'fraicheur', 'aquatique', 'propre'],
    agrume: ['agrume', 'agrumes'], fruite: ['fruite', 'fruitee', 'fruit', 'fruits'],
    oriental: ['oriental', 'orientale'], epice: ['epice', 'epicee', 'epices'],
  };

  const NOTE_ALIASES = {
    rose: ['rose'], jasmin: ['jasmin'], hibiscus: ['hibiscus'], caramel: ['caramel'], chocolat: ['chocolat'],
    praline: ['praline'], cedre: ['cedre'], santal: ['santal'], oud: ['oud'], cuir: ['cuir'], citron: ['citron'],
    orange: ['orange'], bergamote: ['bergamote'], mandarine: ['mandarine'], mangue: ['mangue'], peche: ['peche'],
    pomme: ['pomme'], passion: ['passion'], poivre: ['poivre'], cannelle: ['cannelle'], girofle: ['girofle'],
    musque: ['musque', 'musc', 'musc blanc'], vanille: ['vanille', 'vanillee'], ambre: ['ambre', 'ambree'], encens: ['encens'],
  };

  const OCCASION_ALIASES = {
    quotidien: ['quotidien', 'tous les jours', 'travail', 'bureau', 'journee'],
    soiree: ['soiree', 'soir', 'sortie', 'fete'],
    cadeau: ['cadeau', 'offrir'],
    voyage: ['voyage', 'vacances'],
  };

  const INTENSITY_ALIASES = {
    leger: ['leger', 'legere', 'discret', 'discrete', 'doux', 'douce', 'subtil', 'subtile'],
    equilibre: ['equilibre', 'equilibree', 'modere', 'moderee'],
    intense: ['intense', 'puissant', 'puissante', 'fort', 'forte', 'marque'],
  };

  const DISPLAY_NAMES = {
    floral: 'florale', gourmand: 'gourmande', boise: 'boisée', frais: 'fraîche',
    agrume: 'agrumes', fruite: 'fruitée', oriental: 'orientale', epice: 'épicée',
    musque: 'musquée', vanille: 'vanillée', ambre: 'ambrée',
    rose: 'rose', jasmin: 'jasmin', hibiscus: 'hibiscus', caramel: 'caramel', chocolat: 'chocolat',
    praline: 'praliné', cedre: 'cèdre', santal: 'santal', oud: 'oud', cuir: 'cuir', citron: 'citron',
    orange: 'orange', bergamote: 'bergamote', mandarine: 'mandarine', mangue: 'mangue', peche: 'pêche',
    pomme: 'pomme', passion: 'fruit de la passion', poivre: 'poivre', cannelle: 'cannelle', girofle: 'girofle', encens: 'encens',
    leger: 'discret', equilibre: 'équilibré', intense: 'intense',
    quotidien: 'quotidien', soiree: 'soirée', cadeau: 'cadeau', voyage: 'voyage',
  };


  // Multilingual vocabulary shares the existing canonical profile keys.
  Object.entries({"floral": ["blumig", "blumige", "blumen", "bluten", "floreale", "floreali", "fiori", "flowers"], "gourmand": ["suss", "susse", "suess", "sweet", "dolce", "dolci"], "boise": ["holzig", "holzige", "holz", "woody", "wood", "legnoso", "legnosi", "legno"], "frais": ["frisch", "frische", "fresh", "fresco", "freschi", "acquatico", "aquatic"], "agrume": ["zitrus", "zitrisch", "citrus", "agrumi", "agrumato"], "fruite": ["fruchtig", "fruchtige", "fruity", "fruttato", "fruttati", "frutta"], "oriental": ["orientalisch", "orientalische", "orientali"], "epice": ["wurzig", "wurzige", "gewurze", "spicy", "spices", "speziato", "speziati", "spezie"]}).forEach(([key, words]) => { FAMILY_TERMS[key].push(...words); });
  Object.entries({"rose": ["rosen", "rosa"], "jasmin": ["jasmine", "gelsomino"], "hibiscus": ["hibiskus", "ibisco"], "caramel": ["karamell", "caramello"], "chocolat": ["schokolade", "chocolate", "cioccolato"], "praline": ["pralinato"], "cedre": ["zeder", "zedernholz", "cedar", "cedro"], "santal": ["sandelholz", "sandalwood", "sandalo"], "oud": [], "cuir": ["leder", "leather", "cuoio"], "citron": ["zitrone", "lemon", "limone"], "orange": ["arancia"], "bergamote": ["bergamotte", "bergamot", "bergamotto"], "mandarine": ["mandarin", "mandarino"], "mangue": ["mango"], "peche": ["pfirsich", "peach", "pesca"], "pomme": ["apfel", "apple", "mela"], "passion": ["passionsfrucht", "passion fruit", "frutto della passione"], "poivre": ["pfeffer", "pepper", "pepe"], "cannelle": ["zimt", "cinnamon", "cannella"], "girofle": ["nelke", "gewurznelke", "clove", "chiodi di garofano"], "musque": ["moschus", "musk", "musky", "muschio", "muschiato"], "vanille": ["vanilla", "vaniglia", "vanigliato"], "ambre": ["amber", "ambra", "ambrato"], "encens": ["weihrauch", "incense", "incenso"]}).forEach(([key, words]) => { NOTE_ALIASES[key].push(...words); });
  Object.entries({"quotidien": ["alltag", "taglich", "arbeit", "buro", "everyday", "daily", "work", "office", "quotidiano", "ogni giorno", "lavoro", "ufficio"], "soiree": ["abend", "ausgehen", "feier", "evening", "night", "party", "sera", "serata", "festa"], "cadeau": ["geschenk", "verschenken", "gift", "present", "regalo", "regalare"], "voyage": ["reise", "reisen", "ferien", "urlaub", "travel", "holiday", "vacation", "viaggio", "vacanze"]}).forEach(([key, words]) => { OCCASION_ALIASES[key].push(...words); });
  Object.entries({"leger": ["dezent", "dezente", "leicht", "leichte", "subtle", "light", "soft", "discreto", "discreta", "leggero", "leggera", "delicato"], "equilibre": ["ausgewogen", "ausgewogene", "massig", "balanced", "moderate", "equilibrato", "equilibrata", "moderato"], "intense": ["intensiv", "stark", "starke", "strong", "powerful", "intenso", "intensa", "potente"]}).forEach(([key, words]) => { INTENSITY_ALIASES[key].push(...words); });
  Object.entries(FAMILY_TERMS).forEach(([key, words]) => { FAMILY_ALIASES[key].push(...words); });
  const tmDisplay = {"floral": ["blumig", "floreale", "floral"], "gourmand": ["Gourmand", "gourmand", "gourmand"], "boise": ["holzig", "legnoso", "woody"], "frais": ["frisch", "fresco", "fresh"], "agrume": ["Zitrus", "agrumi", "citrus"], "fruite": ["fruchtig", "fruttato", "fruity"], "oriental": ["orientalisch", "orientale", "oriental"], "epice": ["würzig", "speziato", "spicy"], "musque": ["Moschus", "muschiato", "musky"], "vanille": ["Vanille", "vaniglia", "vanilla"], "ambre": ["Amber", "ambra", "amber"], "rose": ["Rose", "rosa", "rose"], "jasmin": ["Jasmin", "gelsomino", "jasmine"], "hibiscus": ["Hibiskus", "ibisco", "hibiscus"], "caramel": ["Karamell", "caramello", "caramel"], "chocolat": ["Schokolade", "cioccolato", "chocolate"], "praline": ["Praliné", "pralinato", "praline"], "cedre": ["Zeder", "cedro", "cedar"], "santal": ["Sandelholz", "sandalo", "sandalwood"], "oud": ["Oud", "oud", "oud"], "cuir": ["Leder", "cuoio", "leather"], "citron": ["Zitrone", "limone", "lemon"], "orange": ["Orange", "arancia", "orange"], "bergamote": ["Bergamotte", "bergamotto", "bergamot"], "mandarine": ["Mandarine", "mandarino", "mandarin"], "mangue": ["Mango", "mango", "mango"], "peche": ["Pfirsich", "pesca", "peach"], "pomme": ["Apfel", "mela", "apple"], "passion": ["Passionsfrucht", "frutto della passione", "passion fruit"], "poivre": ["Pfeffer", "pepe", "pepper"], "cannelle": ["Zimt", "cannella", "cinnamon"], "girofle": ["Gewürznelke", "chiodi di garofano", "clove"], "encens": ["Weihrauch", "incenso", "incense"], "leger": ["dezent", "discreto", "subtle"], "equilibre": ["ausgewogen", "equilibrato", "balanced"], "intense": ["intensiv", "intenso", "intense"], "quotidien": ["Alltag", "quotidiano", "everyday"], "soiree": ["Abend", "sera", "evening"], "cadeau": ["Geschenk", "regalo", "gift"], "voyage": ["Reise", "viaggio", "travel"]};
  const tmLocaleIndex = ["de", "it", "en"].indexOf(typeof document === "undefined" ? "fr" : document.documentElement.lang.split("-")[0]);
  if (tmLocaleIndex >= 0) Object.keys(DISPLAY_NAMES).forEach(key => { DISPLAY_NAMES[key] = tmDisplay[key]?.[tmLocaleIndex] || DISPLAY_NAMES[key]; });

  const NEGATION_PATTERN = /(?:\bpas\s+(?:(?:trop|fan\s+de)\s+)?|\bsans\s+(?:(?:parfum|accord|note|odeur|profil)s?\s+)?|\b(?:je\s+)?deteste\s+(?:(?:le|la|les|un|une|des)\s+)?(?:(?:parfum|accord|note|odeur|profil)s?\s+)?(?:trop\s+)?|\beviter\s+(?:(?:le|la|les|un|une|des)\s+)?|\bevite\s+(?:(?:le|la|les|un|une|des)\s+)?|\bn['’]?aime\s+pas\s+)(?:(?:de|du|des|d['’]|la|le|les|l['’])\s*)?$/;

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('fr')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’]/g, "'")
      .replace(/[^a-z0-9%€.,'\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function unique(values) {
    return [...new Set((values || []).filter(Boolean))];
  }

  function blankProfile() {
    return {
      version: 1,
      families: [],
      excludedFamilies: [],
      notes: [],
      excludedNotes: [],
      occasions: [],
      intensity: null,
      budgetMax: null,
      liked: [],
      disliked: [],
      discover: [],
      freeText: '',
      updatedAt: Date.now(),
    };
  }

  function normalizeProfile(input) {
    const empty = blankProfile();
    const source = input && typeof input === 'object' ? input : {};
    return {
      ...empty,
      ...source,
      version: 1,
      families: unique(source.families),
      excludedFamilies: unique(source.excludedFamilies),
      notes: unique(source.notes),
      excludedNotes: unique(source.excludedNotes),
      occasions: unique(source.occasions),
      liked: unique(source.liked),
      disliked: unique(source.disliked),
      discover: unique(source.discover),
      budgetMax:
        source.budgetMax === null || source.budgetMax === undefined || source.budgetMax === ''
          ? null
          : (Number.isFinite(Number(source.budgetMax)) ? Number(source.budgetMax) : null),
      updatedAt: Date.now(),
    };
  }

  function phraseIsNegated(text, index) {
    const prefix = text.slice(Math.max(0, index - 36), index);
    return NEGATION_PATTERN.test(prefix) || /(?:\b(?:ohne|kein|keine|keinen|keinem|keiner|nicht|without|no|avoid|senza|niente|evitare)\s+(?:(?:zu|too|troppo|molto)\s+)?|\b(?:mag|mochte)\s+(?:ich\s+)?(?:kein|keine|nicht)\s+|\b(?:don['’]?t|do not)\s+(?:like|want)\s+|\bnon\s+(?:amo|voglio|mi piace)\s+)(?:(?:il|lo|la|l['’]|the|den|die|das)\s*)?$/.test(prefix);
  }

  function extractAliasMatches(text, aliases) {
    const positive = [];
    const negative = [];

    Object.entries(aliases).forEach(([key, words]) => {
      words.forEach((word) => {
        const needle = normalize(word);
        let start = text.indexOf(needle);
        while (start !== -1) {
          const before = start === 0 ? ' ' : text[start - 1];
          const afterIndex = start + needle.length;
          const after = afterIndex >= text.length ? ' ' : text[afterIndex];
          const bounded = !/[a-z0-9]/.test(before) && !/[a-z0-9]/.test(after);
          if (bounded) {
            (phraseIsNegated(text, start) ? negative : positive).push(key);
          }
          start = text.indexOf(needle, start + needle.length);
        }
      });
    });

    return {positive: unique(positive), negative: unique(negative)};
  }

  function parseBudget(text) {
    if (text.includes('€')) return null;
    const parseAmount = (whole, decimals = '') => {
      const decimalPart = String(decimals || '').padEnd(2, '0').slice(0, 2);
      return (Number(whole) * 100) + Number(decimalPart || 0);
    };
    const explicit = text.match(
      /(?:budget|max(?:imum)?|jusqu['’]?a|moins\s+de|sous|bis|unter|up\s+to|under|less\s+than|fino\s+a|meno\s+di|massimo)\s*(?:de\s*)?(?:chf|fr\.?|francs?)?\s*(\d{1,4})(?:[.,](\d{1,2}))?/
    );
    if (explicit) return parseAmount(explicit[1], explicit[2]);

    const currencyBefore = text.match(/(?:chf|fr\.?|francs?)\s*(\d{1,4})(?:[.,](\d{1,2}))?/);
    if (currencyBefore) return parseAmount(currencyBefore[1], currencyBefore[2]);

    const currencyAfter = text.match(/(\d{1,4})(?:[.,](\d{1,2}))?\s*(?:chf|fr\.?|francs?)/);
    if (currencyAfter) return parseAmount(currencyAfter[1], currencyAfter[2]);

    const swissNotation = text.match(/\b(\d{1,4})\s*\.-/);
    return swissNotation ? parseAmount(swissNotation[1]) : null;
  }

  function parseText(value) {
    const text = normalize(value);
    const familyMatches = extractAliasMatches(text, FAMILY_TERMS);
    const noteMatches = extractAliasMatches(text, NOTE_ALIASES);
    const occasionMatches = extractAliasMatches(text, OCCASION_ALIASES);
    const intensityMatches = extractAliasMatches(text, INTENSITY_ALIASES);
    const notes = [];
    const excludedNotes = [];

    notes.push(...noteMatches.positive);
    excludedNotes.push(...noteMatches.negative);

    const intensity = intensityMatches.positive.at(-1) ||
      (intensityMatches.negative.includes('intense') ? 'leger' : null);

    const parsed = {
      families: familyMatches.positive,
      excludedFamilies: familyMatches.negative,
      notes: unique(notes),
      excludedNotes: unique(excludedNotes),
      occasions: occasionMatches.positive,
      freeText: String(value || '').trim(),
    };
    const budgetMax = parseBudget(text);
    if (intensity) parsed.intensity = intensity;
    if (budgetMax != null) parsed.budgetMax = budgetMax;
    return parsed;
  }

  function mergeProfile(profile, patch) {
    const next = normalizeProfile({...profile, ...patch});
    ['families', 'excludedFamilies', 'notes', 'excludedNotes', 'occasions'].forEach((key) => {
      next[key] = unique([...(profile[key] || []), ...(patch[key] || [])]);
    });
    next.families = next.families.filter((item) => !next.excludedFamilies.includes(item));
    next.notes = next.notes.filter((item) => !next.excludedNotes.includes(item));
    return next;
  }

  function productKey(product) {
    return String(product?.id || product?.handle || '');
  }

  function isMaisonSolen(product) {
    return normalize(product?.vendor) === 'maison solen';
  }

  function productText(product) {
    return normalize([
      product.title,
      product.vendor,
      product.type,
      ...(product.tags || []),
      ...(product.collections || []),
      ...(product.families || []),
      product.notes,
      product.summary,
    ].join(' '));
  }

  function olfactoryText(product) {
    return normalize([
      product.type,
      ...(product.tags || []),
      ...(product.collections || []),
      ...(product.families || []),
      product.notes,
    ].join(' '));
  }

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function textHasTerm(text, term) {
    const normalizedTerm = normalize(term);
    if (!normalizedTerm) return false;
    const pattern = new RegExp(`(^|[^a-z0-9])${escapeRegExp(normalizedTerm)}([^a-z0-9]|$)`);
    return pattern.test(text);
  }

  function textHasAny(text, aliases) {
    return (aliases || []).some((alias) => textHasTerm(text, alias));
  }

  function matchingTerms(product, keys) {
    const text = productText(product);
    return (keys || []).filter((key) => textHasAny(text, FAMILY_ALIASES[key] || [key]));
  }

  function matchingNoteTerms(product, keys) {
    const text = productText(product);
    return (keys || []).filter((key) => textHasAny(text, NOTE_ALIASES[key] || [key]));
  }

  function availableVariants(product, budgetMax) {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    return variants.filter((variant) => {
      if (!variant.available) return false;
      if (budgetMax != null && Number(variant.price) > budgetMax) return false;
      return true;
    });
  }

  function looksLikeFragrance(product) {
    const text = productText(product);
    return [
      'parfum', 'fragrance', 'eau de parfum', 'extrait', 'musc', 'brume',
      'maison solen', 'parfum de dubai', 'parfum-de-dubai',
    ].some((term) => text.includes(term));
  }

  function scoreProduct(product, profile, catalogue = []) {
    const key = productKey(product);
    const variants = availableVariants(product, profile.budgetMax);
    if (!product?.available || variants.length === 0 || profile.disliked.includes(key) || !looksLikeFragrance(product)) {
      return {eligible: false, score: Number.NEGATIVE_INFINITY, reasons: [], variant: null};
    }

    const familyMatches = matchingTerms(product, profile.families);
    const noteMatches = matchingNoteTerms(product, profile.notes);
    const excluded = unique([
      ...matchingTerms(product, profile.excludedFamilies),
      ...matchingNoteTerms(product, profile.excludedNotes),
    ]);
    if (excluded.length > 0) {
      return {eligible: false, score: Number.NEGATIVE_INFINITY, reasons: [], variant: null};
    }

    const variant = [...variants].sort((a, b) => Number(a.price) - Number(b.price))[0];
    const reasons = [];
    let score = 1;

    if (familyMatches.length > 0) {
      score += familyMatches.length * 20;
      reasons.push(tmSay("Famille [[0]]", familyMatches.slice(0, 2).map((item) => DISPLAY_NAMES[item] || item).join(' · ')));
    }
    if (noteMatches.length > 0) {
      score += noteMatches.length * 14;
      reasons.push(tmSay("Accords retrouvés : [[0]]", noteMatches.slice(0, 2).map((item) => DISPLAY_NAMES[item] || item).join(' · ')));
    }
    if (profile.liked.includes(key)) {
      score += 40;
      reasons.push(tmSay("Vous l’avez aimé"));
    }
    if (profile.discover.includes(key)) {
      score += 5;
      reasons.push(tmSay("Ajouté à « À découvrir »"));
    }
    if (profile.budgetMax != null) {
      score += 8;
      reasons.push(tmSay("Dans votre budget"));
    }

    if (profile.occasions.length) {
      const text = productText(product);
      const occasionMatches = profile.occasions.filter((occasion) =>
        textHasAny(text, OCCASION_ALIASES[occasion] || [occasion])
      );
      if (occasionMatches.length) {
        score += occasionMatches.length * 6;
        reasons.push(tmSay("Usage indiqué : [[0]]", occasionMatches.map((item) => DISPLAY_NAMES[item] || item).join(' · ')));
      }
    }

    if (profile.intensity) {
      const text = productText(product);
      const intensityTerms = INTENSITY_ALIASES[profile.intensity] || [];
      if (textHasAny(text, intensityTerms)) {
        score += 8;
        reasons.push(tmSay("Profil [[0]]", DISPLAY_NAMES[profile.intensity] || profile.intensity));
      }
    }

    if (!profile.liked.includes(key) && profile.liked.length) {
      const allOlfactoryKeys = Object.keys(FAMILY_ALIASES);
      const candidateText = olfactoryText(product);
      const candidateMarkers = allOlfactoryKeys.filter((marker) =>
        textHasAny(candidateText, FAMILY_ALIASES[marker])
      );
      const likedMarkers = unique(
        catalogue
          .filter((item) => profile.liked.includes(productKey(item)))
          .flatMap((item) => {
            const text = olfactoryText(item);
            return allOlfactoryKeys.filter((marker) => textHasAny(text, FAMILY_ALIASES[marker]));
          })
      );
      const sharedMarkers = candidateMarkers.filter((marker) => likedMarkers.includes(marker));
      if (sharedMarkers.length) {
        score += Math.min(sharedMarkers.length, 2) * 9;
        reasons.unshift(tmSay("Repères proches d’un parfum aimé"));
      }
    }

    if (reasons.length === 0) reasons.push(tmSay("Disponible dans la sélection"));

    return {eligible: true, score, reasons: reasons.slice(0, 3), variant};
  }

  function hasTastePreferences(profile) {
    return Boolean(
      profile?.families?.length || profile?.excludedFamilies?.length || profile?.notes?.length ||
      profile?.excludedNotes?.length || profile?.occasions?.length || profile?.intensity ||
      profile?.budgetMax != null || profile?.liked?.length || profile?.disliked?.length || profile?.discover?.length
    );
  }

  function rankEntries(entries, profile = null) {
    const initialSolenPreference = !hasTastePreferences(profile);
    const ranked = entries.slice().sort((a, b) => {
      const scoreDifference = Number(b.score) - Number(a.score);
      if (scoreDifference !== 0) return scoreDifference;

      if (initialSolenPreference) {
        const brandDifference = Number(isMaisonSolen(b.product)) - Number(isMaisonSolen(a.product));
        if (brandDifference !== 0) return brandDifference;
      }

      const priceDifference = Number(a.variant?.price || Infinity) - Number(b.variant?.price || Infinity);
      if (priceDifference !== 0) return priceDifference;

      // With preferences, Maison Solen only breaks a true relevance and price tie.
      if (Number(a.score) > 1) {
        const brandDifference = Number(isMaisonSolen(b.product)) - Number(isMaisonSolen(a.product));
        if (brandDifference !== 0) return brandDifference;
      }

      return productKey(a.product).localeCompare(productKey(b.product), 'fr');
    });

    return ranked.map((entry) => {
      const commercialTie = isMaisonSolen(entry.product) && Number(entry.score) > 1 && ranked.some((other) =>
        other !== entry &&
        !isMaisonSolen(other.product) &&
        Number(other.score) === Number(entry.score) &&
        Number(other.variant?.price) === Number(entry.variant?.price)
      );
      const initialTie = initialSolenPreference && isMaisonSolen(entry.product) && Number(entry.score) === 1;
      return (commercialTie || initialTie)
        ? {...entry, commercialReason: tmSay("Création suisse Maison Solen proposée parmi les disponibilités.")}
        : entry;
    });
  }

  function canUsePreferenceStorage(globalObject) {
    try {
      const privacy = globalObject.Shopify?.customerPrivacy;
      return privacy?.currentVisitorConsent?.().preferences === 'yes';
    } catch (_error) {
      return false;
    }
  }

  function createEngine(catalogue = [], globalObject = globalThis) {
    let products = Array.isArray(catalogue) ? catalogue : [];
    let profile = blankProfile();
    let provider = null;
    let persistenceEnabled = false;
    const subscribers = new Set();

    function notify(status = 'change', source = 'profile') {
      const detail = {status, source, profile: getProfile()};
      subscribers.forEach((subscriber) => subscriber(detail));
      if (typeof globalObject.dispatchEvent === 'function' && typeof globalObject.CustomEvent === 'function') {
        globalObject.dispatchEvent(new globalObject.CustomEvent('tm:fragrance-profile', {detail}));
      }
    }

    function getProfile() {
      return JSON.parse(JSON.stringify(profile));
    }

    function setProfile(next, options = {}) {
      profile = normalizeProfile(next);
      autosaveIfEnabled();
      notify('change', options.source || 'set');
      return getProfile();
    }

    function update(patch, options = {}) {
      profile = mergeProfile(profile, patch || {});
      autosaveIfEnabled();
      notify('change', options.source || 'update');
      return getProfile();
    }

    function hasPreferences() {
      return Boolean(
        profile.families.length || profile.excludedFamilies.length || profile.notes.length ||
        profile.excludedNotes.length || profile.occasions.length || profile.intensity ||
        profile.budgetMax != null || profile.liked.length || profile.disliked.length ||
        profile.discover.length || profile.freeText
      );
    }

    function score(product) {
      return scoreProduct(product, profile, products);
    }

    function rank(input = products, limit = 3) {
      const entries = (Array.isArray(input) ? input : [])
        .map((product) => ({product, ...score(product)}))
        .filter((entry) => entry.eligible);
      return rankEntries(entries, profile).slice(0, Math.max(0, limit));
    }

    async function recommend(limit = 3) {
      if (typeof provider === 'function') {
        try {
          const provided = await provider({profile: getProfile(), catalogue: [...products], limit, localRank: rank});
          if (Array.isArray(provided)) {
            const requestedKeys = unique(provided.map((item) => {
              if (typeof item === 'string' || typeof item === 'number') return String(item);
              return productKey(item?.product || item);
            }));
            const validatedProducts = products.filter((product) => requestedKeys.includes(productKey(product)));
            if (validatedProducts.length) return rank(validatedProducts, limit);
          }
        } catch (_error) {
          // A future provider must never make the free local guide unavailable.
        }
      }
      return rank(products, limit);
    }

    function subscribe(subscriber) {
      if (typeof subscriber !== 'function') return () => {};
      subscribers.add(subscriber);
      subscriber({status: 'current', source: 'subscribe', profile: getProfile()});
      return () => subscribers.delete(subscriber);
    }

    function writeRemembered() {
      if (!canUsePreferenceStorage(globalObject)) return {ok: false, reason: 'consent'};
      try {
        globalObject.localStorage.setItem(STORAGE_KEY, JSON.stringify({expiresAt: Date.now() + STORAGE_TTL, profile}));
        return {ok: true};
      } catch (_error) {
        return {ok: false, reason: 'storage'};
      }
    }

    function autosaveIfEnabled() {
      if (!persistenceEnabled) return;
      const result = writeRemembered();
      if (!result.ok && result.reason === 'consent') clearRemembered();
    }

    function remember() {
      const result = writeRemembered();
      if (result.ok) persistenceEnabled = true;
      return result;
    }

    function loadRemembered() {
      if (!canUsePreferenceStorage(globalObject)) return false;
      try {
        const raw = globalObject.localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        const saved = JSON.parse(raw);
        if (!saved.expiresAt || saved.expiresAt <= Date.now()) {
          globalObject.localStorage.removeItem(STORAGE_KEY);
          return false;
        }
        profile = normalizeProfile(saved.profile);
        persistenceEnabled = true;
        notify('change', 'remembered');
        return true;
      } catch (_error) {
        try {
          globalObject.localStorage?.removeItem(STORAGE_KEY);
        } catch (_storageError) {
          // Ignore unavailable storage after discarding an unreadable value.
        }
        return false;
      }
    }

    function clearRemembered(options = {}) {
      const wasEnabled = persistenceEnabled;
      let hadSavedProfile = false;
      persistenceEnabled = false;
      try {
        hadSavedProfile = Boolean(globalObject.localStorage?.getItem(STORAGE_KEY));
        globalObject.localStorage?.removeItem(STORAGE_KEY);
      } catch (_error) {
        // Nothing else is required when storage is unavailable.
      }
      if (options.notify && (wasEnabled || hadSavedProfile)) {
        notify('change', options.source || 'memory-cleared');
      }
    }

    function reset() {
      profile = blankProfile();
      clearRemembered();
      notify('change', 'reset');
      return getProfile();
    }

    function setRecommendationProvider(nextProvider) {
      provider = typeof nextProvider === 'function' ? nextProvider : null;
    }

    function setCatalogue(nextCatalogue) {
      products = Array.isArray(nextCatalogue) ? nextCatalogue : [];
      api.catalogue = products;
    }

    const api = {
      catalogue: products,
      getProfile,
      setProfile,
      update,
      parse: parseText,
      score,
      rank,
      recommend,
      subscribe,
      hasPreferences,
      remember,
      loadRemembered,
      clearRemembered,
      reset,
      canPersist: () => canUsePreferenceStorage(globalObject),
      setRecommendationProvider,
      setCatalogue,
    };

    return api;
  }

  function parseCatalogueNode(node) {
    if (!node) return [];
    try {
      const parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_error) {
      return [];
    }
  }

  async function readCatalogue(documentObject, globalObject) {
    const node = documentObject?.getElementById('tm-fragrance-catalogue');
    const initial = parseCatalogueNode(node);
    if (!node || Number(node.dataset?.page || 1) <= 1) return initial;

    const recoveryUrl = node.dataset?.recoveryUrl;
    if (!recoveryUrl || typeof globalObject.fetch !== 'function' || typeof globalObject.DOMParser !== 'function') {
      return initial;
    }

    try {
      const response = await globalObject.fetch(recoveryUrl, {credentials: 'same-origin'});
      if (!response.ok) return initial;
      const html = await response.text();
      const recoveredDocument = new globalObject.DOMParser().parseFromString(html, 'text/html');
      const recoveredNode = recoveredDocument.getElementById('tm-fragrance-catalogue');
      const recovered = parseCatalogueNode(recoveredNode);
      return recovered.length ? recovered : initial;
    } catch (_error) {
      return initial;
    }
  }

  function ensurePrivacyApi(globalObject) {
    if (globalObject.Shopify?.customerPrivacy?.currentVisitorConsent) return Promise.resolve(true);
    if (typeof globalObject.Shopify?.loadFeatures !== 'function') return Promise.resolve(false);
    return new Promise((resolve) => {
      try {
        globalObject.Shopify.loadFeatures(
          [{name: 'consent-tracking-api', version: '0.1'}],
          (error) => resolve(!error && Boolean(globalObject.Shopify?.customerPrivacy))
        );
      } catch (_error) {
        resolve(false);
      }
    });
  }

  function bootBrowser(globalObject) {
    if (globalObject.TMFragrance?.ready) return;

    let resolveReady;
    const ready = new Promise((resolve) => {
      resolveReady = resolve;
    });
    const engine = createEngine([], globalObject);
    const api = Object.assign(engine, {ready});
    globalObject.TMFragrance = api;

    const initialize = async () => {
      api.setCatalogue(await readCatalogue(globalObject.document, globalObject));
      api.loadRemembered();
      resolveReady(api);
      const detail = {status: 'ready', source: 'catalogue', profile: api.getProfile()};
      if (typeof globalObject.CustomEvent === 'function') {
        globalObject.dispatchEvent(new globalObject.CustomEvent('tm:fragrance-profile', {detail}));
      }

      ensurePrivacyApi(globalObject).then(() => {
        if (api.canPersist()) {
          if (!api.hasPreferences()) api.loadRemembered();
        } else {
          api.clearRemembered({notify: true, source: 'consent-revoked'});
        }
      });
    };

    if (globalObject.document?.readyState === 'loading') {
      globalObject.document.addEventListener('DOMContentLoaded', initialize, {once: true});
    } else {
      initialize();
    }

    globalObject.document?.addEventListener('visitorConsentCollected', () => {
      if (api.canPersist()) {
        if (!api.hasPreferences()) api.loadRemembered();
      } else {
        api.clearRemembered({notify: true, source: 'consent-revoked'});
      }
    });
  }

  if (typeof window !== 'undefined') bootBrowser(window);
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {createEngine, parseText, scoreProduct, blankProfile, normalize};
  }
})();
